<template>
  <div class="account-operation">
    <el-page-header @back="$router.go(-1)" content="账号运营"> </el-page-header>

    <el-tabs v-model="activeName" type="card" style="margin-top: 20px">
      <el-tab-pane label="成果展示" name="1">
        <Result />
      </el-tab-pane>
      <el-tab-pane label="英雄榜" name="2" lazy>
        <Ranking category="yy" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Ranking from "../ranking.vue";
import Result from "./result.vue";
export default {
  components: { Result, Ranking },
  data() {
    return {
      activeName: "1",
    };
  },
};
</script>

<style lang="less" scoped>
.account-operation {
  padding: 20px 33px;
  background-color: #ffffff;
}
</style>